var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-provider',{ref:"field",attrs:{"mode":_vm.mode,"name":_vm.name,"vid":_vm.vid,"persist":_vm.persist,"rules":_vm.rules,"slim":true},scopedSlots:_vm._u([{key:"default",fn:function(ref){
  var dirty = ref.dirty;
  var pristine = ref.pristine;
  var valid = ref.valid;
  var invalid = ref.invalid;
  var pending = ref.pending;
  var touched = ref.touched;
  var untouched = ref.untouched;
  var errors = ref.errors;
  var validate = ref.validate;
  var passes = ref.passes;
  var reset = ref.reset;
return [_c('div',{class:{ 'form-input': true, 'form-input--error': errors.length }},[_vm._t("default",null,{"errors":errors,"valid":valid,"invalid":invalid}),_c('transition',{attrs:{"name":"fade"}},[(_vm.show_errors && errors.length)?_c('div',{class:_vm.errors_class},[_vm._v(" "+_vm._s(errors[0])+" ")]):_vm._e()])],2)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }